export default __webpack_public_path__ + "static/media/cus_1.e3097000.webp";